b<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <i-card-vertical
        headerTitle="회원승인 요청목록"
        device="multi"
        contentsClass="overflow-x-hidden overflow-y-auto pr-5"
        :IsUseEditorBox="true"
        :IsUseTopAddition="true"
      >
        <template v-slot:EditorBox>
          <v-row no-gutters>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="startDate"
                placeholder="시작일자"
                :menu="true"
                :dateOnly="true"
                :allowMaxDate="minDate"
                @getDate="setSearchDate($event, 'start')"
              ></i-date-time-picker>
            </v-col>
            <span class="pt-1 mx-1">~</span>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="endDate"
                placeholder="종료일자"
                :menu="true"
                :dateOnly="true"
                :allowMinDate="minDate"
                @getDate="setSearchDate($event, 'end')"
              ></i-date-time-picker>
            </v-col>
          </v-row>
        </template>
        <template v-slot:topAddition>
          <p class="mt-1 mb-3">*처리(승인/거절) 완료된 요청은 일주일 후 삭제 처리 됩니다.</p>
        </template>
        <template v-slot:body>
          <DxDataGrid
            id="memberApprovalDataGrid"
            class="layout-col-height005"
            style="width: 100%; height: 100%"
            :ref="dxDataGridRef"
            :data-source="gridMain"
            :remote-operations="false"
            :hover-state-enabled="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            :show-borders="true"
            :show-row-lines="true"
            :focused-row-enabled="true"
            key-expr="rgstNo"
            @editing-start="onEditingStart"
            @editor-preparing="onEditorPreparing"
          >
            <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />
            <DxColumn data-field="userCd" data-type="string" :visible="false"></DxColumn>
            <DxColumn data-field="clntNmLeader" data-type="string" alignment="left" width="200px" caption="대표법인" :allow-editing="false" />
            <DxColumn data-field="clntNm" data-type="string" alignment="left" width="200px" caption="고객사명" :allow-editing="false" />

            <DxColumn data-field="rgstNo" data-type="string" alignment="center" caption="사업자등록번호" :allow-editing="false" />

            <DxColumn data-field="rpstNm" data-type="string" alignment="center" caption="대표자명" :allow-editing="false" />

            <DxColumn data-field="joinNm" data-type="string" alignment="center" caption="가입 구분" :allow-editing="false" />

            <DxColumn
              data-field="approvalStatus"
              data-type="string"
              width="250px"
              alignment="center"
              caption="승인"
              cell-template="approvalStatusTemplate"
              :calculate-display-value="(e) => displayApproval(e)"
              :allow-editing="false"
            ></DxColumn>
            <template #approvalStatusTemplate="{ data: cellInfo }">
              <div v-if="cellInfo.data.approvalStatus == 'N'">
                <v-btn outlined elevation="0" small class="mr-1 grid-btn" color="error" @click="btnRefuse(cellInfo)">거절</v-btn>
                <v-btn @click="btnApprove(cellInfo)" outlined elevation="0" color="primary" small class="ml-1 grid-btn">승인</v-btn>
              </div>
              <div v-else-if="cellInfo.data.approvalStatus == 'A'">{{ cellInfo.displayValue }}</div>
              <div style="color: red" v-else-if="cellInfo.data.approvalStatus == 'R'">{{ cellInfo.displayValue }}</div>
            </template>

            <DxColumn data-field="reqDt" data-type="string" alignment="center" caption="요청일자" :allow-editing="false" />

            <DxColumn data-field="addrs" data-type="string" width="500px" alignment="left" caption="주소" :allow-editing="false" />
          </DxDataGrid>
        </template>
      </i-card-vertical>

      <i-card-right class="d-flex" headerTitle :useBtnList="buttonUseList" @btnSearch="btnSearch(true)" @btnDelete="btnDelete()"></i-card-right>
    </v-sheet>
    <!-- 고객승인 (대표법인 승인 팝업) -->
    <i-dx-popup :popupVisible="popupVisible" title="고객 승인" @popupCloseButtonClick="closeBtn" height="25vh" width="30vw">
      <template v-slot:grid>
        <v-card style="padding: 0 20px; display: block !important">
          <v-row>
            <p>대표법인</p>
            <DxDropDownBox
              class="hidden-sm-and-down"
              ref="dropDownBoxRefClnt"
              width="100%"
              :value="selectedClntReaderInfo.clntId"
              :data-source="[{ clntId: selectedClntReaderInfo.clntId, clntNm: selectedClntReaderInfo.clntNm }]"
              stylingMode="filled"
              :drop-down-options="{ width: '100%' }"
              :defer-rendering="false"
              :placeholder="clickedApproveClntInfo.clntNm"
              display-expr="clntNm"
              value-expr="clntId"
            >
              <ClientSelectGrid ref="clientSelectGridRef" @selectedData="onGridSelectionChanged"> </ClientSelectGrid>
            </DxDropDownBox>
          </v-row>
          <v-row class="d-flex align-end mt-4">
            <v-btn width="100%" color="#1b53f3" elevation="0" large @click="btnApprovePopup()"><p style="color: white">승 인</p></v-btn>
          </v-row>
        </v-card>
      </template>
    </i-dx-popup>
  </v-container>
</template>
<script>
import {
  clientMemberApproval,
  clientMemberRefuse,
  deleteClientMemberApproval,
  getClientMemberApproval,
} from '@/api/adminManagement/clientMemberApprovalManage'
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import { getCurrentDate, getPreMonth } from '@/utils/common.js'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가

// 고객사 승인 팝업
import IDxPopup from '@/components/common/iDxPopup.vue'
import DxDropDownBox from 'devextreme-vue/drop-down-box'
import ClientSelectGrid from '@/components/esgCommon/clientSelectGrid.vue'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'memberApprovalDataGrid',
  components: {
    IDateTimePicker,
    IDxPopup,
    DxDropDownBox,
    ClientSelectGrid,
  },
  data() {
    return {
      dxDataGridRef: 'memberApprovalDataGrid',
      buttonUseList: [
        'btnSearch', // 조회
        'btnDelete', // 삭제
      ],
      authCd: this.getAuthCd(),
      gridMain: [],
      hireGubnList: [],
      groupAuthList: [],
      groupAuthDataSource: [],
      companyGroupList: [],
      phonePattern: /^\d{3}-(\d{4}||\d{3})-\d{4}$/i,
      startDate: getPreMonth(3),
      endDate: getPreMonth(0),
      searchStartDate: getPreMonth(3).replace(/[^0-9]/g, ''),
      searchEndDate: getPreMonth(0).replace(/[^0-9]/g, ''),
      searchMinDate: getCurrentDate(),
      searchMaxDate: getPreMonth(3),
      minDate: getCurrentDate(),
      showSearchPanel: false,
      // 고객승인 팝업 관련
      popupVisible: false, // 고객승인 (대표법인 승인 팝업)
      selectedClntReaderInfo: {}, // 고객승인 (대표법인 승인 팝업) 선택된 고객사 ID
      clickedApproveClntInfo: {}, // 고객승인 (대표법인 승인 팝업) 그리드에서 클릭된 고객사정보
    }
  },
  computed: {},
  beforeMount() {},
  activated() {
    // 일반 메뉴로 들어올 때는 기존 조회 기준인 3개월로 조회
    this.applySearchPeriod(3)
  },
  mounted() {
    // this.btnSearch(true)
  },
  methods: {
    // 대시보드에서 넘어올 경우 최근 2개월을 조회 기간으로 설정
    applySearchPeriod(defaultStartMonths, defaultEndMonths = 0) {
      const query = this.$route.query || {}
      const fromDashboard =
        query.from === 'dashboard' && query.period === '2months'

      const startDate = getPreMonth(
        fromDashboard ? 2 : defaultStartMonths
      )
      const endDate = fromDashboard
        ? getCurrentDate()
        : getPreMonth(defaultEndMonths)

      // 날짜 선택기에 표시할 값
      this.startDate = startDate
      this.endDate = endDate

      // API 조회에 사용할 값
      this.searchStartDate = startDate.replace(/[^0-9]/g, '')
      this.searchEndDate = endDate.replace(/[^0-9]/g, '')

      this.btnSearch(true)
    },
    btnFilter() {
      this.showSearchPanel = !this.showSearchPanel
      console.log('btnFilter!!!')
    },
    //------------------------------------------
    //  검색 년월일 포맷
    //------------------------------------------
    setSearchDate(e, div) {
      if (div === 'start') {
        this.searchMinDate = e
        this.searchStartDate = e.replace(/[^0-9]/g, '')
      } else if (div === 'end') {
        this.searchMaxDate = e
        this.searchEndDate = e.replace(/[^0-9]/g, '')
      }
    },
    //------------------------------------------
    //  회원승인 요청목록 조회
    //------------------------------------------
    async btnSearch(isNotify) {
      this.openLoading('searching')

      let params = {
        searchStartDate: this.searchStartDate,
        searchEndDate: this.searchEndDate,
      }
      try {
        const response = await getClientMemberApproval(params, isNotify)
        if (response.success) {
          this.gridInit(this.GetDataGrid(this.dxDataGridRef))
          this.gridMain = []
          this.gridMain = response.list
          this.gridMain = response.list.map((item) => {
            item.addrs = `(${item.zipCd}) ${item.addrs1} ${item.addrs2}`
            // 승인 요청시 default 상태 처리
            if (item.approvalStatus === 'N') {
              item.groupAuth = 'normal'
            }
            return item
          })
          this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
        }
      } catch (error) {
        console.error('getClientMemberApproval error catch >> ', error)
      } finally {
        this.endLoading()
      }
    },
    //------------------------------------------
    //  회원승인 요청목록 삭제
    //------------------------------------------
    async btnDelete() {
      let selectedMainRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()

      if (!selectedMainRows.length) {
        this.vToastify(this.$t('삭제할 데이터를 선택해주세요.'), 'info')
        return
      }
      if (!selectedMainRows.findIndex((element) => element.approvalStatus == 'N')) {
        this.vToastify(this.$t('미승인 회원은 삭제할 수 없습니다.'), 'info')
        return
      }

      this.vToastifyPrompt(
        this.$t('선택한 데이터를 삭제하시겠습니까?'),
        'info',
        async () => {
          this.GetDataGrid(this.dxDataGridRef).beginUpdate()
          this.GetDataGrid(this.dxDataGridRef).saveEditData()
          this.openLoading('searching')
          try {
            await deleteClientMemberApproval(selectedMainRows, true)
            this.btnSearch(false)
          } catch (error) {
            console.error('deleteClientMemberApproval error catch >> ', error)
          } finally {
            this.GetDataGrid(this.dxDataGridRef).endUpdate()
            this.endLoading()
          }
        },
        null,
        true
      )
    },
    //------------------------------------------
    //  회원승인 거절
    //------------------------------------------
    btnRefuse(cellInfo) {
      this.vToastifyPrompt(
        this.$t(`[${cellInfo.data.clntNm}] 승인거절 하시겠습니까?`),
        'info',
        () => {
          this.vToastifyPrompt(
            this.$t(`승인거절 후 해당 데이터를 삭제 하시겠습니까?`),
            'info',
            async () => {
              this.openLoading('saving')
              let params = {
                userCd: cellInfo.data.userCd,
                rgstNo: cellInfo.data.rgstNo,
                deleteFlag: true,
              }
              try {
                const response = await clientMemberRefuse(params)
                if (response.success) {
                  this.btnSearch(false)
                }
              } catch (error) {
                console.error('clientMemberRefuse error catch >> ', error)
              } finally {
                this.endLoading()
              }
            },
            async () => {
              this.openLoading('saving')
              let params = {
                userCd: cellInfo.data.userCd,
                rgstNo: cellInfo.data.rgstNo,
                deleteFlag: false,
              }
              try {
                const response = await clientMemberRefuse(params)
                if (response.success) {
                  this.btnSearch(false)
                }
              } catch (error) {
                console.error('clientMemberRefuse error catch >> ', error)
              } finally {
                this.endLoading()
              }
            },
            true
          )
        },
        null,
        true
      )
    },
    //------------------------------------------
    //  회원승인
    //------------------------------------------
    async btnApprove(cellInfo) {
      this.popupVisible = true
      this.clickedApproveClntInfo = cellInfo.data
      this.$nextTick(() => {
        console.log('#### this.$refs.clientSelectGridRef', this.$refs.clientSelectGridRef)
        this.$refs.clientSelectGridRef.searchClient()
      })
    },

    //------------------------------------------
    //  회원승인 팝업
    //------------------------------------------
    onGridSelectionChanged(e) {
      console.log('#### e', e)
      this.selectedClntReaderInfo = e
      this.$refs.dropDownBoxRefClnt.instance.close()
    },
    btnApprovePopup() {
      const msg = this.selectedClntReaderInfo.clntId
        ? `대표법인: ${this.selectedClntReaderInfo.clntNm}</br>[${this.clickedApproveClntInfo.clntNm}] </br>승인 하시겠습니까?`
        : `[${this.clickedApproveClntInfo.clntNm}] </br>승인 하시겠습니까?`
      this.vToastifyPrompt(
        this.$t(msg),
        'info',
        async () => {
          this.openLoading('saving')
          let params = {
            clntIdLeader: this.selectedClntReaderInfo.clntId ? this.selectedClntReaderInfo.clntId : null,
            userCd: this.clickedApproveClntInfo.userCd,
            rgstNo: this.clickedApproveClntInfo.rgstNo,
          }
          try {
            const response = await clientMemberApproval(params)
            if (response.success) {
              this.popupVisible = false
              this.$refs.dropDownBoxRefClnt.instance.close()
              this.btnSearch(false)
            }
          } catch (error) {
            console.error('clientMemberApproval error catch >> ', error)
          } finally {
            this.endLoading()
          }
        },
        null,
        true
      )
    },
    closeBtn() {
      this.popupVisible = false
    },
    ///////////////////////////////////////
    /*           DataGrid Event          */
    ///////////////////////////////////////
    onEditingStart(e) {
      if (
        (e.data.approvalStatus == 'R' || e.data.approvalStatus == 'A') &&
        (e.column.dataField == 'connDtS' ||
          e.column.dataField == 'connDtE' ||
          e.column.dataField == 'groupAuth' ||
          e.column.dataField == 'hpNo' ||
          e.column.dataField == 'hireGubn')
      ) {
        e.cancel = true
        return
      }
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    formatDate(dateString) {
      const date = new Date(dateString)
      let year = date.getFullYear()
      let month = (date.getMonth() + 1).toString().padStart(2, '0')
      let day = date.getDate().toString().padStart(2, '0')
      let hours = date.getHours().toString().padStart(2, '0')
      let minutes = date.getMinutes().toString().padStart(2, '0')
      let seconds = date.getSeconds().toString().padStart(2, '0')

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    displayApproval(element) {
      let approveDate = this.formatDate(element.updatedAt ? element.updatedAt : element.createdAt)
      if (element.approvalStatus == 'A') {
        return `승인 (${approveDate})`
      } else if (element.approvalStatus == 'R') {
        return `승인거절 (${approveDate})`
      } else {
        return
      }
    },
  },
}
</script>

<style scoped></style>
